// extracted by mini-css-extract-plugin
export default {"module":"callToAction_module__2tf1K","content":"callToAction_content__1sHa1","title":"callToAction_title__ZAuvh","desc":"callToAction_desc__RDzVW"};